/* eslint-disable max-lines */
// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import config from '../../../share/config';
import handler from '../../../share/util/apiResultValidator';
import treeView from "../../../share/components/vue/TreeView";
import resource from '../../../share/util/resourceMap';
import reprogram from '../../../share/util/reprogram';
import util from '../../../share/util/utils';
import vehicle from '../../../share/util/vehicle';
import authority from '../../../share/util/authorityCheck';
import alert from '../../../share/alert';
import loading from '../../../share/components/vue/ProcessingIcon';
import error from '../../../common/nodejs/errors';
import api from '../../../common/api';
import individualDiagnose from '../../../share/util/individualDiagnose';
const publishedUnitListTestMode = require('../../../data/testMode/publishedUnits.json');

const FUNCTION_TABS = [
  { type: config.EXECUE_FUNCTION_TYPE_RPR, index: 0 }
];

export default {
  name: "informationTabs",
  data() {
    return {
      showModalPassword: false,
      processing: false,
      systemTables: { published: null, unpublished: null },
      isPublished: true,
      inquiry: '',
      suFlow: true,
      unconformedSystems: [],
      relationReproProcessMsg: '',
      functionMode: '',
      useVehicleScreenTabs: true,
      isModalQueueAvailable: false,
      activeTabArray: [false],
      reproFuncTabTitle: '',
      pfcFileSystem: {},
      pfcFilePassword: '',
      // 許諾変更モーダル関連
      showModalConsent: false,
      consentTable: [],
      unitId: '',
      selectSwidConsentType: null,
      consentState: '',
      pfcId: '',
      updateProgramFlg: false,
      merchandisePfcList: { published: null, unpublished: null },
      serialNoFlg: false
    };
  },

  watch: {
    $route: {
      immediate: true,
      /**
       * ページ遷移を監視する
       * @param {object} to 遷移後の情報
       */
      handler: function (to) {
        // タブの切り替えを行う
        if (to.name === 'systemTable' || to.name === 'suSystemTable') {
          this.computeActivatedTab(config.EXECUE_FUNCTION_TYPE_RPR);
        } else {
          this.computeActivatedTab(to.name);
        }
      }
    }
  },

  components: {
    'system-tree': treeView,
    'processing-view': loading,
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),
    ...mapActions('targetUnit', ['setTargetUnit']),
    ...mapActions('vehicle', ['updateVehicleInfo']),
    ...mapActions('cache', ['cacheSystemTable', 'cacheDisplayMode', 'cacheUnconformedSystems', 'cacheDisplayReproTypeMode', 'cacheMerchandiseInfo', 'cacheSelectMerchandiseInfo']),
    ...mapActions('table', ['setNativeSystemTable', 'setSystemTblModalFlag']),
    ...mapActions('netAppConnector', ['getPairingStatus']),

    //  リプロ機能を利用可能かどうかの判定
    //  技本ユーザーはシステムテーブル一覧は作成しない
    //  既販車判定は表示しない
    isReproFuncAvailable() {
      return !this.isTechnicalHq && this.systemTable && !this.vehicleInfo.is_sold_vehicle;
    },

    // リプロ機能を利用可能かどうかの判定
    isDiagFuncAvailable() {
      return true;
    },

    // Vehicle, SystemInformation 画面によってタブコンポーネントの表示を切り替え
    setVclScreenTabsAvailable(arg) {
      this.useVehicleScreenTabs = arg;
    },

    // SSM5 サービス機能のタブを切り替え
    switchFunctionTab(type) {
      const currentRout = this.$router.currentRoute.value.name;
      this.computeActivatedTab(type);
      if (type === config.EXECUE_FUNCTION_TYPE_RPR) {
        if (this.suFlow) {
          if (currentRout !== 'suSystemTable') this.$router.push({ name: 'suSystemTable' });
        } else {
          if (currentRout !== 'systemTable') this.$router.push({ name: 'systemTable' });
        }
        // Menu⇒診断⇒リプロの順で操作された場合に警告ダイアログの再起呼び出しを開始
        this.runModalQueue();
      }
    },

    // SSM5 サービス機能のアクティブなタブの設定
    computeActivatedTab(funcType) {
      const screens = FUNCTION_TABS.filter(e => e.type === funcType);
      if (screens.length > 0) {
        for (let i = 0; i < this.activeTabArray.length; i++) {
          this.activeTabArray[i] = i === screens[0].index;
        }
      } else {
        // タブ定義以外の機能の場合、タブを全て非活性にする
        this.activeTabArray.fill(false);
      }
    },

    // 現在の公開・非公開の表示モードを切り替える
    switchPublishmentMode(val) {
      if (val !== null) {
        this.cacheDisplayMode(false);
      }
      this.isPublished = val;
      this.$emit('updateReproTreeView', { isPublished: this.isPublished });
      this.cacheDisplayMode(val);
    },

    // リプロ機能のタブに表示される文言をシステム一覧のテーブル種別によって変更する
    changeReproFuncTabName(val) {
      this.cacheDisplayReproTypeMode(val);

      // アップデートプログラム一覧ではツリービューを非表示にする
      const isVisibleTreeView = val !== "updateProgram";
      this.$emit('visibleTreeView', isVisibleTreeView);

      if (["campaign", "update", "restore"].includes(val)) {
        this.$emit('updateReproTreeView', { isPublished: this.isPublished });
      }

      // タブの表示を切り換える
      const messageMap = {
        // 個別ECU画面に遷移するためupdate/restoreはタブに表示されない
        update: "message.header_vehicle_system_update_tree_Modules",
        restore: "message.header_vehicle_system_restore_tree_Modules",
        updateProgram: "message.header_vehicle_system_updateProgram_tree_modules",
        updateChange: "message.header_vehicle_system_updateProgram_tree_modules",
      };
      this.reproFuncTabTitle = messageMap[val] ?? "message.header_vehicle_system_tree_Modules";
    },

    // システム詳細画面の表示内容を設定する
    filterUiConfiguration(system) {
      const ret = {};
      if (this.displayReproTypeMode === 'update') {
        ret.nextMessage = system.updateReproInfo.nextMessage;
        ret.nextPaneBg = system.updateReproInfo.nextPaneBg;
      } else if (this.displayReproTypeMode === 'restore') {
        ret.nextMessage = system.restoreReproInfo.nextMessage;
        ret.nextPaneBg = system.restoreReproInfo.nextPaneBg;
      } else if (this.displayReproTypeMode === 'updateProgram') {
        // 商品一覧で商品が選択されたとき、商品に紐づくシステム一覧を表示する。
        this.getPfcFileList(system.merchandiseCode);
        this.updateProgramFlg = true;
        return this.updateProgramFlg;
      } else {
        ret.nextMessage = system.normalReproInfo.nextMessage;
        ret.nextPaneBg = system.normalReproInfo.nextPaneBg;
      }
      return ret;
    },

    /**
     * 選択された商品コードでリプロありのシステム一覧を表示する
     * @param {string} merchandiseCode 商品一覧から選択された商品コード
     * @returns
     */
    getPfcFileList: function (merchandiseCode) {
      // 商品を選択する前のシステム一覧をキャッシュに保存
      this.cacheSystemTable(this.systemTables);
      const tables = { published: [], unpublished: [] };
      for (const publishedStatus of Object.keys(tables)) {
        for (const unitInfo of this.systemTable[publishedStatus]) {
          if (unitInfo.merchandise_code_list.includes(merchandiseCode)) {
            // 選択された商品コードのリプロが存在するシステムのみ表示する
            unitInfo.merchandiseCode = merchandiseCode;
            tables[publishedStatus].push(unitInfo);
          }
        }

        tables[publishedStatus] = this.setCcuFlag(tables[publishedStatus]);
        tables[publishedStatus] = resource.getVehicleSystemStatus(tables[publishedStatus], this.suFlow);
      }

      this.systemTables = {
        published: this.formatTable(this.filterSmtRkeList(tables.published.vehicleSystemList)),
        unpublished: this.formatTable(this.filterSmtRkeList(tables.unpublished.vehicleSystemList))
      };
      this.cacheSystemTable(this.systemTables);
      this.cacheMerchandiseInfo({ published: this.systemTables.published, unpublished: this.systemTables.unpublished });
      return;
    },
    // リプロ種別によってPFCファイルIDを返す
    getReproTypeFileId: function (item) {
      // リプロ実行中から復活の場合、item.idを参照する
      if (item.directRecoveryToRpr) {
        return item.fileId;
      }
      const prefix = 'message.a_';
      if (this.suFlow) {
        if (this.displayReproTypeMode === 'campaign') {
          if (item.normalReproResource.order === 0) return item.normalReproInfo.id;
        } else if (this.displayReproTypeMode === 'update') {
          if (item.updateReproResource.order === 0) return item.updateReproInfo.id;
        } else {
          if (item.restoreReproResource.order === 0) return item.restoreReproInfo.id;
        }
        return null;
      } else {
        if (this.displayReproTypeMode === 'campaign') {
          if (item.normalReproResource.startsWith(prefix) || item.normalReproResource.order === 0) return item.normalReproInfo.id;
        } else if (['update', 'updateChange'].includes(this.displayReproTypeMode)) {
          if (item.updateReproResource.startsWith(prefix) || item.updateReproResource.order === 0) return item.updateReproInfo.id;
        } else {
          if (item.restoreReproResource.startsWith(prefix) || item.restoreReproResource.order === 0) return item.restoreReproInfo.id;
        }
        return null;
      }
    },

    // SystemTeble画面から任意のシステムがテーブルから選択されたときの処理
    clickReproTableRow(system) {
      const info = this.filterUiConfiguration(system);
      if (this.updateProgramFlg === true) {
        // 商品が選択されたとき
        this.cacheSystemTable(this.systemTables);
        this.cacheSelectMerchandiseInfo(system.merchandiseCode);
        this.$emit('updateReproTreeView', { isPublished: this.isPublished });
        this.updateProgramFlg = false;
        return;
      }
      this.callSelectReproEcu(system);
      const params = {
        unitId: system.id,
        // 選択された画面（リプロタイプ別）の設定を作成
        fileId: this.getReproTypeFileId(system),
        name: system.name,
        publishmentMode: this.isPublished,
        nextMessage: info.nextMessage,
        nextPaneBg: info.nextPaneBg,
        isExecutable: this.isExecuteRepro(system.reproExecutable),
        needInquiry: system.needInquiry,
        showDetail: system.showDetail,
        type2DisplayUnitId: system.type2DisplayUnitId,
        merchandiseCode: system.merchandiseCode
      };
      // 個別InquiryCheck
      this.isInquiryCheck(params);
    },

    /**
     * リプログラミングツリーの選択状態をecu選択時にも適応させるため、親コンポーネントのinformationMainの処理を実行する。
     * 子コンポーネントのsystemFileTableからも処理を行う必要があるため、メソッドとして再定義して、値を親に引き渡す。
     * @param {object} system 選択されたシステム
     */
    callSelectReproEcu(system) {
      this.$emit('selectReproEcu', system);
    },

    /**
     * 任意のシステムがテーブルから選択されたときの処理を行う
     * この関数は、子画面である DtcTable から呼ばれる
     * @param {object} selected 選択された行
     */
    async clickDtcTableRow(selected) {
      // DTC/制御作動履歴 統合メニュー判定
      const targetMenu = this.individualMenus.menu_list.find(menu => menu.system_name === selected.systemID);
      const isCombined = individualDiagnose.areDiagAndVchEnabled(targetMenu);

      // 統合メニューが有効な場合はindividualDtcVchに、そうでない場合はindividualDiagCodeに遷移
      const funcId = isCombined ? config.INDIVIDUAL_FUNCTION_DTC_VCH : config.INDIVIDUAL_FUNCTION_DIAG_CODE;

      this.$router.push({
        name: 'individualEcuTable',
        query: {
          systemId: selected.systemID,
          funcId: funcId,
          sameSystemFlg: false
        }
      });
    },

    /**
     * リプロツリーから任意のシステムが選択されたときの処理を実行する。\
     * この関数は、親画面である InformationMain から ref 参照で呼び出される。
     * @param {object} system 選択されたシステム
     * @param {boolean} needStartQueue モーダル処理を実施するか否か
     */
    async clickReproTreeNode(system, needStartQueue) {
      this.computeActivatedTab(config.EXECUE_FUNCTION_TYPE_RPR);
      const currentRoute = this.$router.currentRoute.value.name;
      if (needStartQueue) {
        // リプロ以外の画面から遷移した時に実行する
        if (this.suFlow) {
          if (currentRoute !== 'suSystemTable') await this.$router.push({ name: 'suSystemTable' });
        } else {
          if (currentRoute !== 'systemTable') await this.$router.push({ name: 'systemTable' });
        }
        if (!system) {
          if (needStartQueue) this.runModalQueue();
          return;
        }
      }
      if (!system) return;
      // 詳細画面が表示可能な場合は System 詳細画面に遷移
      const tbl = this.isPublished ? this.systemTables.published : this.systemTables.unpublished;
      const idx = tbl.findIndex(unit => system.data.id === unit.id);
      if (!tbl || idx === -1) {
        if (needStartQueue) this.runModalQueue();
        return;
      }

      if (["updateChange", "update", "restore"].includes(this.displayReproTypeMode)) {
        const isTypeMerchant = tbl[idx].isSuSystem ? tbl[idx].reproExecutable.merchant?.order !== 99 : tbl[idx].reproExecutable.merchant;
        const isTypeRestore = tbl[idx].isSuSystem ? tbl[idx].reproExecutable.restore?.order !== 99 : tbl[idx].reproExecutable.restore;
        // 商品選択後の画面
        if (isTypeMerchant) {
          this.cacheDisplayReproTypeMode("update");
        } else if (isTypeRestore) {
          this.cacheDisplayReproTypeMode("restore");
        }
      }

      const info = this.filterUiConfiguration(tbl[idx]);
      const params = {
        unitId: tbl[idx].id,
        fileId: this.getReproTypeFileId(tbl[idx]),
        name: tbl[idx].name,
        publishmentMode: this.isPublished,
        nextMessage: info.nextMessage,
        nextPaneBg: info.nextPaneBg,
        isExecutable: this.isExecuteRepro(tbl[idx].reproExecutable),
        needInquiry: tbl[idx].needInquiry,
        showDetail: this.isShowDetail(tbl[idx]),
        type2DisplayUnitId: this.suFlow ? util.getType2DisplayUnitId(tbl[idx].id, this.resources) : null,
        merchandiseCode: tbl[idx].merchandiseCode
      };

      if (!this.suFlow || params.showDetail) {
        // 選択状態のツリービューノードを変更
        this.isInquiryCheck(params);
      }
    },

    // 診断機能ツリーから任意のシステムが選択されたとき、診断画面に遷移
    // この関数は、親画面である InformationMain から ref 参照で呼び出される
    clickDiagTreeNode(system) {
      system;
      this.computeActivatedTab(config.EXECUE_FUNCTION_TYPE_DIAG);
      // すでに診断画面が表示されている場合は何もしない
      if (this.$router.currentRoute.value.name !== 'dtcTable') {
        this.$router.push({ name: 'dtcTable' });
      }
    },

    serialNoControl(serialNo) {
      this.enterSerialNo = serialNo;
      this.serialNoFlg = true;
    },

    // systemFileTable画面からPFCファイルが選択されたときの処理
    // File画面で選択されたPFCが「品質改善・機能向上・復元」のどれに属するかを後続処理へ反映
    selectReproSystem(pfcFile) {
      this.enterSerialNo = "true";
      // 選択されたPFCファイルのリプロ種別をキャッシュ
      this.cacheDisplayReproTypeMode(pfcFile.reproTypeMode);
      const formattedData = this.getFormattedTargetUnitData({ pfc_file_id: pfcFile.pfc_file_id });
      if (formattedData === null) {
        return;
      }
      const info = this.filterUiConfiguration(formattedData);
      const system = {
        unitId: formattedData.id,
        // 選択された画面（リプロタイプ別）の設定を作成
        fileId: this.getReproTypeFileId(formattedData),
        name: formattedData.name,
        publishmentMode: this.isPublished,
        nextMessage: info.nextMessage,
        nextPaneBg: info.nextPaneBg,
        isExecutable: this.isExecuteRepro(formattedData.reproExecutable),
        needInquiry: formattedData.needInquiry,
        showDetail: formattedData.showDetail,
        type2DisplayUnitId: formattedData.type2DisplayUnitId,
        serialNumber: this.enterSerialNo
      };

      // SU 法規の制御条件により System 詳細画面を表示できなければ、Vehicle 画面にとどまる
      if (this.suFlow && !system.showDetail) {
        // Menu ⇒ 診断 ⇒ リプロの順で操作された場合に警告ダイアログの再起呼び出しを開始
        this.runModalQueue();
        return;
      }
      if ((this.displayReproTypeMode === "update" || this.displayReproTypeMode === "restore") && system.fileId && this.serialNumber === null) {

        // 機能向上・復元のみパスワード確認ダイアログに行く
        this.pfcFilePassword = '';
        this.pfcFileSystem = system;
        this.showModalPassword = true;
      } else {
        this.serialNoFlg = false;
        this.moveToSystemInfomation(system);
      }
    },

    // 機能向上パスワード認証
    checkPfcFilePassword: async function () {

      // APIを利用するために必要な値を取得する
      const fileId = this.pfcFileSystem.fileId;
      const unitId = this.pfcFileSystem.unitId;
      // dialogを閉じてくるくる表示
      this.showModalPassword = false;
      // パスワード確認
      this.processing = true;
      const isPassword = await api.postCall(
        config.REPRO,
        '/netApps/' + this.netAppId + '/' + unitId + '/' + fileId + '/distributorPfcFile/password',
        { pfc_file_password: this.pfcFilePassword }
      );
      this.processing = false;
      handler.validate(
        handler.validateTypes.all,
        isPassword, this, null,
        () => {
          // 処理が成功したときのコールバック処理
          // パスワードの確認結果
          if (isPassword.data.is_password_confirm === true) {
            const system = !this.pfcFileSystem.needInquiry ? this.pfcFileSystem : null;
            this.moveToSystemInfomation(system);
          } else {
            // エラーを出して入力ダイアログに戻る
            const messages = this.$t("message.messege_repro_merchantability_password_error");
            alert.showError(this, null, messages, () => {
              this.pfcFilePassword = '';
              this.showModalPassword = true;
            });
          }
        },
        (result) => {
          // 処理が失敗したときのコールバック処理
          if (result.behaviorType === handler.behaviorTypes.logout) {
            this.logout(this);
          }
        }
      );
    },

    // 表示されているリプロ種別テーブルによって詳細ボタンの表示有無を設定
    isShowDetail: function (item) {
      if (this.displayReproTypeMode === 'campaign') {
        return item.showDetail.normal;
      } else {
        return this.displayReproTypeMode === 'update' ? item.showDetail.merchant : item.showDetail.restore;
      }
    },

    // SystemInfomation画面に遷移
    moveToSystemInfomation(system = null) {
      // 個別情報画面の表示に必要なパラメタの設定
      const param = {
        unitId: system ? system.unitId : this.inquiry.unitId,
        fileId: system ? system.fileId : this.getFileInformation().id,
        name: system ? system.name : this.inquiry.name,
        publishmentMode: this.isPublished,
        directRecoveryToRpr: false,   // ユーザー操作によりリプロ開始するためフラグをリセット
        type2DisplayUnitId: system ? system.type2DisplayUnitId : this.inquiry.type2DisplayUnitId,
        paneConfig: {
          nextMessage: system ? system.nextMessage : this.getFileInformation().nextMessage,
          nextPaneBg: system ? system.nextPaneBg : this.getFileInformation().nextPaneBg,
          showWarning: system ? system.showWarning : this.getFileInformation().showWarning,
          isExecutable: system ? system.isExecutable : this.getFileInformation().isExecutable
        }
      };
      this.setTargetUnit(param);
      // 同じ画面の場合は遷移しないよう制御
      const constname = this.$router.currentRoute.value.name;
      if (constname !== 'systemInformation') {
        this.$emit('setIsSystemHeaderDisplay', true);
        this.$router.push({ name: 'systemInformation', params: { previousDisplayName: 'systemFileTable' } });
      }
    },

    // CCU 判定フラグの設定
    setCcuFlag: function (tbl) {
      if (!tbl) return [];
      return tbl.map(ecu => {
        const i = this.resources.findIndex(unit => unit.id === ecu.id);
        return { ...ecu, is_ccu: i !== -1 ? this.resources[i].name.toLowerCase() === 'ccu' : false };
      });
    },

    // 対象システム ID に対応したシステム名称を取得してテーブルに格納
    // 対象システム ID を文字列から数値に変換（ソート機能対応のため）
    formatTable: function (tbl) {
      const ret = tbl;
      for (const i in ret) {
        ret[i].name = '';
        ret[i].id = parseInt(ret[i].id);
      }
      return ret;
    },

    setLatestReproSystems: async function () {
      // システム一覧を API から取得
      this.processing = true;
      const systemMode = vehicle.getVehicleSystemMode(this.isTestMode, this.isTechnicalHq);
      const res = await this.setNativeSystemTable({
        netAppId: this.netAppId,
        obj: this,
        isBothTable: authority.hasUnpublishedPermission(this.authGroup),
        mode: systemMode
      });
      this.processing = false;
      if (!res.isValid) {
        alert.showError(this, null, res.data.message, () => {
          if (res.data.behaviorType === handler.behaviorTypes.logout) this.logout(this);
        });
      }
      const ccuPblTmp = this.setCcuFlag(this.systemTable.published);
      const ccuUnpblTmp = this.setCcuFlag(this.systemTable.unpublished);
      const tmpPbl = resource.getVehicleSystemStatus(ccuPblTmp, this.suFlow);
      const tmpUnpbl = resource.getVehicleSystemStatus(ccuUnpblTmp, this.suFlow);
      this.hasVehicleConnectWarn = reprogram.hasFailedStateUnit(this.systemTable.published, this.resources) || reprogram.hasFailedStateUnit(this.systemTable.unpublished, this.resources);
      this.systemTables = {
        published: this.formatTable(this.filterSmtRkeList(tmpPbl.vehicleSystemList)),
        unpublished: this.formatTable(this.filterSmtRkeList(tmpUnpbl.vehicleSystemList))
      };
    },

    refreshAllReproSystems: async function () {
      if (!this.isTestMode) {
        await this.setLatestReproSystems();
      } else {
        // テストモード用データの設定
        this.systemTables = {
          published: this.systemTable.published,
          unpublished: this.systemTable.unpublished
        };
      }
      this.cacheSystemTable(this.systemTables);

      // 親のツリービューを更新
      this.$emit('updateReproTreeView', { isPublished: this.isPublished });
      // 法規不適合のシステムが存在する場合は、警告色のテーブル表示に変更
      if (this.suFlow) this.changeToUnconformedDisplay();
      // サインアウト後、直接リプロに復帰してからシステム個別画面に戻る手順で
      // 操作されたときのために、画面表示用の設定値を準備する
      if (this.targetUnit && this.targetUnit.directRecoveryToRpr) this.setPreviousTarget();
      // ダイアログの準備（ただし許諾更新後のテーブル再取得を除く）
      if (this.isModalQueueAvailable) await this.setupModalQueue();
    },

    // リプロ対象のデータファイル情報を取得
    getFileInformation: function () {
      const tbl = this.isPublished ? this.systemTables.published : this.systemTables.unpublished;
      let ret = {};
      // 選択されたシステム ID をテーブルから検索して、
      // 合致するシステムのファイル ID とメッセージ、背景色設定を返す
      const index = tbl.findIndex(system => system.id === this.inquiry.unitId);
      if (index !== -1) {
        const info = this.filterUiConfiguration(tbl[index]);
        ret = {
          id: this.getReproTypeFileId(tbl[index]),
          nextMessage: info.nextMessage,
          nextPaneBg: info.nextPaneBg,
          isExecutable: this.isExecuteRepro(tbl[index].reproExecutable)
        };
      }
      // 合致するシステムのファイルがなければ、選択された時点のファイル ID とメッセージを返す
      else {
        const info = this.filterUiConfiguration(this.inquiry);
        ret = {
          id: this.getReproTypeFileId(this.inquiry),
          nextMessage: info.nextMessage,
          nextPaneBg: info.nextPaneBg,
          isExecutable: this.isExecuteRepro(this.inquiry.reproExecutable)
        };
      }
      return ret;
    },

    // 前回リプロ実行されていたファイルを特定して、システム個別画面の表示設定を準備
    setPreviousTarget: function () {
      const param = {
        unitId: this.targetUnit.unitId,
        fileId: this.getReproTypeFileId(this.targetUnit),
        name: this.targetUnit.name,
        publishmentMode: true,
        directRecoveryToRpr: true,
        type2DisplayUnitId: this.targetUnit.type2DisplayUnitId,
        paneConfig: {}
      };
      let tbl = this.systemTables.published;
      let index = tbl.findIndex(el => { return this.isReprogrammableInfo(el); });
      let mode = true;
      if (index === -1) {
        tbl = this.systemTables.unpublished;
        index = tbl.findIndex(el => { return this.isReprogrammableInfo(el); });
        mode = false;
      }
      param.publishmentMode = mode;
      this.cacheDisplayMode(mode);
      let info = null;
      if (index !== -1) {
        info = this.filterUiConfiguration(tbl[index]);
      }

      param.paneConfig.nextMessage = index !== -1 ? info.nextMessage : '';
      param.paneConfig.nextPaneBg = index !== -1 ? info.nextPaneBg : '';
      param.paneConfig.isExecutable = index !== -1 ? this.isExecuteRepro(tbl[index].reproExecutable) : false;
      this.setTargetUnit(param);
    },

    // PFCファイルIDを算出
    isReprogrammableInfo: function (item) {
      const pfcFileList = [item.normalReproInfo.id, item.updateReproInfo.id, item.restoreReproInfo.id];
      const isReprogrammable = pfcFileList.some(i => i === this.targetUnit.fileId);
      return isReprogrammable;
    },


    isExecuteRepro: function (flg) {
      if (this.displayReproTypeMode === 'campaign') {
        if (!this.suFlow) {
          return flg.normal;
        } else {
          // 市場措置がリプロ可だった場合、他のECUが「未設定」ではないかチェックする
          return (flg.normal.order === 0);
        }
      } else if (this.displayReproTypeMode === 'update') {
        return !this.suFlow ? flg.merchant : flg.merchant.order === 0;
      } else {
        return !this.suFlow ? flg.restore : flg.restore.order === 0;
      }
    },

    changeToUnconformedDisplay: function () {
      let updatedPbl = this.systemTables.published;
      let updatedUnpbl = this.systemTables.unpublished;

      // 車両情報取得後、1 回目のVehicle画面を表示する系の処理
      // 法規適合へ変更して 2 回目以降に Vehicle 画面を表示する場合、su_conform はすべて true なので本分岐には入らない
      // 法規不適合なシステムが存在する場合、適合システムの表示をリプロ無しまたはエラーの状態の表示に変更
      // 法規対象システム:isSuSystem = true, 法規適合:suConform = true, 法規不適合:suConform = false
      const isAllConformed = !this.systemTables.published.some(item => item.isSuSystem === true && item.suConform === false);
      if (this.suFlow && !isAllConformed) {
        updatedPbl = resource.setFakeTableDisplay(updatedPbl);
        updatedUnpbl = resource.setFakeTableDisplay(updatedUnpbl);
      }
      this.systemTables = { published: updatedPbl, unpublished: updatedUnpbl };
      this.cacheSystemTable(this.systemTables);
    },

    // 公開/非公開ファイル一覧から関連リプロ対象システムを取得する関数
    computeRelationReproContents: function () {
      // 非公開の関連リプロ中システムを取得する権限があるか
      const auth = authority.hasUnpublishedPermission(this.authGroup);
      // related_repro_flag = true のみフィルタ
      const relationPbl = this.systemTables.published.filter(item => item.related_repro_flag);
      const relationUnpbl = auth ? this.systemTables.unpublished.filter(item => item.related_repro_flag) : [];
      // 関連リプロ中システムが 1 つ以上なら、id ⇒ ユニット名に変換し、リストに格納
      const pblNameConverted = relationPbl.map(system => this.putSystemName(system.id));
      const unpblNameConverted = relationUnpbl.length > 0 ? relationUnpbl.map(system => this.putSystemName(system.id)) : [];
      // ダイアログの文言を生成
      const pblMessageText = pblNameConverted && pblNameConverted.length > 0 ? pblNameConverted.join(', ') : '';
      const unpblMessageText = unpblNameConverted && unpblNameConverted.length > 0 ? unpblNameConverted.join(', ') : '';
      let msg = this.$t('message.message_vehicle_continuous_repro_system_exist') + '<br/>' + this.$t('message.message_vehicle_repro_execution_below') + '<br/>';
      if (auth && relationUnpbl.length > 0) {
        // 非公開システムの表示権限有、かつ関連リプロ中の非公開システムが存在する場合は、公開・非公開の一覧を分ける
        msg = msg + '<br/>' + this.$t('message.label_vehicle_published') + '<br/>' + pblMessageText;
        msg = msg + '<br/>' + this.$t('message.label_vehicle_unpublished') + '<br/>' + unpblMessageText;
      } else {
        msg = msg + '<br/>' + pblMessageText;
      }
      return relationPbl.length < 1 && relationUnpbl.length < 1 ? null : msg;
    },

    // 対象ユニットIDをシステム名に変換する関数
    putSystemName: function (unitId) {
      const targetUnitDisplayData = vehicle.getTargetUnitDisplayNames(this.resources, this.language);
      const unitName = targetUnitDisplayData[unitId];
      return unitName;
    },

    // 公開/非公開ファイル一覧から関連リプロ対象システムを取得する関数
    getRelationReproMessage: function () {
      const auth = authority.hasUnpublishedPermission(this.authGroup);
      // related_repro_flag = true のみフィルタ
      const relationPbl = this.systemTables.published.filter(item => item.isRelatedRepro);
      const relationUnpbl = auth ? this.systemTables.unpublished.filter(item => item.isRelatedRepro) : [];
      // 関連リプロ中システムが 1 つ以上なら、id ⇒ ユニット名に変換し、リストに格納
      const pblNameConverted = relationPbl.map(system => this.putSystemName(system.id));
      const unpblNameConverted = relationUnpbl.length > 0 ? relationUnpbl.map(system => this.putSystemName(system.id)) : [];
      // ダイアログの文言を生成
      const pblMessageText = pblNameConverted && pblNameConverted.length > 0 ? pblNameConverted.join(', ') : '';
      const unpblMessageText = unpblNameConverted && unpblNameConverted.length > 0 ? unpblNameConverted.join(', ') : '';
      let msg = this.$t('message.message_vehicle_continuous_repro_system_exist') + '<br/>' + this.$t('message.message_vehicle_repro_execution_below') + '<br/>';
      if (auth && relationUnpbl.length > 0) {
        // 非公開システムの表示権限有、かつ関連リプロ中の非公開システムが存在する場合は、公開・非公開の一覧を分ける
        msg = msg + '<br/>' + this.$t('message.label_vehicle_published') + '<br/>' + pblMessageText;
        msg = msg + '<br/>' + this.$t('message.label_vehicle_unpublished') + '<br/>' + unpblMessageText;
      } else {
        msg = msg + '<br/>' + pblMessageText;
      }
      return relationPbl.length < 1 && relationUnpbl.length < 1 ? '' : msg;
    },

    // Display message for two step pfc file
    getTwoStepReproMessage: async function () {
      const targetUnitDisplayData = vehicle.getTargetUnitDisplayNames(this.resources, this.language);
      const publishedSystemNameList = [];
      const unpublishedSystemNameList = [];
      this.systemTables.published.forEach(item => {
        const publishTwoStepChildList = [item.normalReproInfo.isTwoStepChild, item.updateReproInfo.isTwoStepChild];
        if (publishTwoStepChildList.some(e => e === true) && targetUnitDisplayData[item.id]) {
          publishedSystemNameList.push(targetUnitDisplayData[item.id]);
        }
      });
      if (authority.hasUnpublishedPermission(this.authGroup)) {
        this.systemTables.unpublished.forEach(item => {
          const unpublishTwoStepChildList = [item.normalReproInfo.isTwoStepChild, item.updateReproInfo.isTwoStepChild];
          if (unpublishTwoStepChildList.some(e => e === true) && targetUnitDisplayData[item.id]) {
            unpublishedSystemNameList.push(targetUnitDisplayData[item.id]);
          }
        });
      }
      if (publishedSystemNameList.length > 0 || unpublishedSystemNameList.length > 0) {
        const param = { this: this, netAppId: this.netAppId };
        this.processing = true;
        const result = await this.getPairingStatus(param);
        this.processing = false;
        if (result.isConnected) {
          const pairingStatus = result.response.data;
          if (!reprogram.isRunningReproPolling(pairingStatus.repro_status)) {
            let msg = this.$t('message.message_reprogram_available_for_subsequent_file') + '<br/><br/>';
            if (publishedSystemNameList.length > 0 && unpublishedSystemNameList.length > 0) {
              msg += this.$t('message.label_vehicle_published') + '<br/>' + publishedSystemNameList.join(', ');
              msg += '<br/><br/>' + this.$t('message.label_vehicle_unpublished') + '<br/>' + unpublishedSystemNameList.join(', ');
            } else {
              msg += (publishedSystemNameList.length > 0) ? publishedSystemNameList.join(', ') : unpublishedSystemNameList.join(', ');
            }
            return msg;
          }
        }
      }
      return null;
    },

    setupModalQueue: async function () {
      this.modalQueue = [];
      // リプロ実行中でなければ、車両情報を取得成功・失敗のダイアログを Queue 追加
      const isReproProcessing = this.viewMode === config.PROCESS_REPRO_PROCESSING || this.viewMode === config.PROCESS_REPRO_COMPLETED;
      // 車種 DB に該当 VIN が存在しない場合は、Queue 生成しない
      if (!isReproProcessing && !this.vehicleInfo.vehicle.spec.model) {
        if (!this.isTestMode) {
          // SSM5 非サポート車種が接続されたが、システムが取得できた場合の特別対応
          // リプログラミング有無およびリプログラミング可否の項目を「対象外」に差し替え、許諾および詳細の操作をマスク
          const notAplicable = { order: 98, label: 'message.c_status_vehicle_system_unsupprted_vin' };
          const unsupportStyle = 'bk-unsupported';
          if (this.systemTables.published && this.systemTables.published.length > 0) {
            for (let i = 0; i < this.systemTables.published.length; i++) {
              this.systemTables.published[i].normalReproResource = notAplicable;
              this.systemTables.published[i].updateReproResource = notAplicable;
              this.systemTables.published[i].restoreReproResource = notAplicable;
              this.systemTables.published[i].reproExecutable = { normal: notAplicable, merchant: notAplicable, restore: notAplicable };
              this.systemTables.published[i].showDetail = { normal: false, merchant: false, restore: false };
              this.systemTables.published[i].bgStyle = {
                swid: { normal: unsupportStyle, merchant: unsupportStyle, restore: unsupportStyle },
                hwid: unsupportStyle,
                romid: { normal: unsupportStyle, merchant: unsupportStyle, restore: unsupportStyle },
                other: unsupportStyle
              };
            }
          }
          if (this.systemTables.unpublished && this.systemTables.unpublished.length > 0) {
            for (let j = 0; j < this.systemTables.unpublished.length; j++) {
              this.systemTables.unpublished[j].normalReproResource = notAplicable;
              this.systemTables.unpublished[j].updateReproResource = notAplicable;
              this.systemTables.unpublished[j].restoreReproResource = notAplicable;
              this.systemTables.unpublished[j].reproExecutable = { normal: notAplicable, merchant: notAplicable, restore: notAplicable };
              this.systemTables.unpublished[j].showDetail = { normal: false, merchant: false, restore: false };
              this.systemTables.unpublished[j].bgStyle = {
                swid: { normal: unsupportStyle, merchant: unsupportStyle, restore: unsupportStyle },
                hwid: unsupportStyle,
                romid: { normal: unsupportStyle, merchant: unsupportStyle, restore: unsupportStyle },
                other: unsupportStyle
              };
            }
          }
          this.cacheSystemTable(this.systemTables);
          this.modalQueue.push({ type: 'warning', msg: this.$t('message.message_vehicle_system_unsupprted_vin') });
          return;
        }
      }
      if (this.hasVehicleConnectWarn) {
        if (!isReproProcessing) this.modalQueue.push({ type: 'warning', msg: this.$t('message.warning_vehicle_system_list') });
      } else {
        // テストモードでは車両情報取得成功の通知を表示しない
        if (!this.isTestMode && !isReproProcessing) this.modalQueue.push({ type: 'success', msg: this.$t('message.success_vehicle_system_list') });
      }
      // 2 段階リプロ途中の警告ダイアログ
      const twoStepMsg = await this.getTwoStepReproMessage();
      if (twoStepMsg) this.modalQueue.push({ type: 'warning', msg: twoStepMsg });
      // 関連リプロ途中の警告ダイアログ
      const relationMsg = this.getRelationReproMessage();
      if (!this.isTestMode && relationMsg) this.modalQueue.push({ type: 'info', msg: relationMsg });
    },

    runModalQueue: function () {
      const queue = this.modalQueue;

      // 遷移前の画面がexecuteからの場合、成功と警告ダイアログは表示しない
      if (queue && queue.length > 0 && util.getPreviousDisplayName(this.$route) !== 'execute') {
        switch (queue[0].type) {
          case 'success':
            alert.showSuccess(this, null, queue[0].msg, () => {
              this.modalQueue.shift();
              this.$nextTick(() => { this.runModalQueue(); });
            });
            break;
          case 'warning':
            alert.showWarning(this, null, queue[0].msg, () => {
              this.modalQueue.shift();
              this.$nextTick(() => { this.runModalQueue(); });
            });
            break;
          case 'info':
            alert.showInfo(this, null, queue[0].msg, () => {
              this.modalQueue.shift();
              this.$nextTick(() => { this.runModalQueue(); });
            });
            break;
          default:
            break;
        }
      }
    },

    // テーブル取得成功メッセージダイアログを表示しないよう制御
    setModalQueueAvailable: function (arg) {
      this.isModalQueueAvailable = arg;
    },

    // SMT/RKE の表示制御特別対応
    filterSmtRkeList: function (list) {
      const tmpList = [...list];
      const ret = list.filter(ecu => {
        const targetEcu = this.resources.filter(e => e.id === ecu.id);
        if (targetEcu.length < 1) return false;
        const hasRke = targetEcu[0].name ? targetEcu[0].name.indexOf('RKE_CGW') > -1 : false;
        const hasTpms = targetEcu[0].name ? targetEcu[0].name.indexOf('TPMS_CGW') > -1 : false;
        if (hasRke) {
          if (ecu.idResponseType === 'no') return false;
          const smtArr = tmpList.filter(e => this.resources.some(r => r.id === e.id && (r.name.indexOf('SMT_IDT') > -1 || r.name.indexOf('SMT_PMN') > -1)));
          if (this.suFlow) {
            return !smtArr.some(smt => smt.installationResource.order === 0);
          } else {
            const isInstalled = smtArr.some(smt => {
              const tmpArr = smt.installationResource.split('.');
              const tmpStr = tmpArr.length > 1 ? tmpArr[1] : '';
              return tmpStr.startsWith('a_');
            });
            return !isInstalled;
          }
        } else if (hasTpms) {
          if (this.suFlow) {
            return (ecu.installationResource.order === 0 && (ecu.idResponseType === 'ok' || ecu.idResponseType === 'ng'));
          } else {
            const tmpArr = ecu.installationResource.split('.');
            const tmpStr = tmpArr.length > 1 ? tmpArr[1] : '';
            return (tmpStr.startsWith('a_') && (ecu.idResponseType === 'ok' || ecu.idResponseType === 'ng'));
          }
        } else {
          return true;
        }
      });
      return ret;
    },

    // 構成情報の整合性に問題がある場合、問合せダイアログ表示
    sbrConfirmDialog: function () {
      const message = this.$t('message.message_vehicle_system_configuration_data_issue');
      alert.showError(this, null, message, () => { });
    },

    // 240830_v250_過去包含クリアのFile画面実装に伴う追加処理----------------------------------------
    // 共通処理------------------------------
    /**
     * Vehicle画面では取得できなかったデータを含めて、resourceMapから各情報をセットしたデータを取得。
     * @param additionalData pfc_file_id,swid_consentを含むオブジェクト
     * @return pfc_file_idまたはswid_consentを追加したvehicle画面テーブル形式のデータ（1件）
    */
    getFormattedTargetUnitData: function (additionalData) {
      // publish/unpublishのAPI戻り値データ形式で、該当するデータを抽出
      const targetRowData = this.isPublished ? this.systemTable.published.find((e) => parseInt(e.id) === this.targetUnit.unitId) :
        this.systemTable.unpublished.find((e) => parseInt(e.id) === this.targetUnit.unitId);

      if (targetRowData !== undefined && targetRowData !== null) {
        const targetReprogrammableInfoKey = this.displayReproTypeMode === 'campaign' ? 'normal' : this.displayReproTypeMode === 'update' ? 'merchantability' : 'restore';
        for (const key in additionalData) {
          targetRowData.reprogrammable_info[targetReprogrammableInfoKey][key] = additionalData[key];
        }
        const formattedData = this.formatTable(resource.getVehicleSystemStatus(this.setCcuFlag([targetRowData]), this.suFlow).vehicleSystemList);
        return formattedData[0];
      }
      return null;
    },

    // 個別 Inquiry有無check
    isInquiryCheck: async function (system) {
      if (system.needInquiry) {
        this.processing = true;
        this.inquiry = system;
        const param = {
          netAppId: this.netAppId,
          endPoint: '',
          this: this,
          unitId: system.unitId,
          type: config.REPRO
        };

        // 車両情報の更新を監視する watcher を登録
        const watcherInstance = this.$watch('inquiryStatus', async (val) => {
          // 車両情報取得失敗
          if (val === config.POLLING_FAILURE) {
            watcherInstance();
            this.processing = false;
            const failure = this.vehicleError.validatorResult;
            if (failure) {
              // ネットワーク接続エラーとセッション情報エラーは警告メッセージで表示する
              if (failure.causeType === handler.causeTypes.networkError || failure.causeType === handler.causeTypes.invalidSessionToken) {
                alert.showWarning(this, null, this.vehicleError.message, () => {
                  if (this.vehicleError.behaviorType === handler.behaviorTypes.logout)
                    this.logout(this);
                  else if (this.vehicleError.behaviorType === handler.behaviorTypes.resetSession)
                    this.resetSession(this);
                });
                return;
              }
              // テレマティクス判定エラーならシステム個別画面に遷移しない
              else if (error.TELEMATICS_ECU_NOT_INSTALLED === failure.consoleCode) {
                alert.showError(this, null, this.vehicleError.message, () => { });
                return;
              }
              // 上記以外のエラーの表示
              alert.showError(this, null, this.vehicleError.message, () => { this.logout(this); });
            } else {
              // バリデータ情報がない場合はエラーメッセージを表示する
              alert.showError(this, null, this.vehicleError.message, () => { this.logout(this); });
            }
          }
          // 車両情報取得成功
          else if (val === config.POLLING_COMPLETED) {
            watcherInstance();
            // Refresh published and unpublished unit list
            await this.setLatestReproSystems();
            this.processing = false;

            this.moveToSystemFile();
          }
        });
        this.updateVehicleInfo(param);
      }
      // 個別 Inquiry が不要
      else {
        this.moveToSystemFile(system);
      }
    },

    // システムの個別情報画面に遷移
    moveToSystemFile(system = null) {
      // 個別情報画面の表示に必要なパラメタの設定
      const param = {
        unitId: system ? system.unitId : this.inquiry.unitId,
        fileId: system ? system.fileId : this.getFileInformation().id,
        name: system ? system.name : this.inquiry.name,
        publishmentMode: this.isPublished,
        directRecoveryToRpr: false,   // ユーザー操作によりリプロ開始するためフラグをリセット
        type2DisplayUnitId: system ? system.type2DisplayUnitId : this.inquiry.type2DisplayUnitId,
        paneConfig: {
          nextMessage: system ? system.nextMessage : this.getFileInformation().nextMessage,
          nextPaneBg: system ? system.nextPaneBg : this.getFileInformation().nextPaneBg,
          isExecutable: system ? system.isExecutable : this.getFileInformation().isExecutable
        },
        merchandiseCode: system?.merchandiseCode
      };
      this.setTargetUnit(param);
      // 同じ画面の場合は遷移しないよう制御
      const constname = this.$router.currentRoute.value.name;
      if (constname !== 'systemFileTable') {
        this.$emit('setIsSystemHeaderDisplay', true);
        this.$router.push({ name: 'systemFileTable', params: { previousDisplayName: this.suFlow ? 'suSystemTable' : 'systemTable' } });
      }
    },

    // System画面関連処理----------------------
    // swid_consentの取得または更新があった際のtargetUnitデータ更新処理
    updateTargetUnitData: function (updateData) {
      this.pfcId = updateData.pfc_file_id;
      const formattedData = this.getFormattedTargetUnitData(updateData);
      if (formattedData !== null) {
        // 個別情報画面の表示に必要なパラメタの設定
        const info = this.filterUiConfiguration(formattedData);
        const param = {
          unitId: this.targetUnit.unitId,
          fileId: this.getReproTypeFileId(formattedData),
          name: this.targetUnit.name,
          publishmentMode: this.isPublished,
          directRecoveryToRpr: false,   // ユーザー操作によりリプロ開始するためフラグをリセット
          type2DisplayUnitId: this.targetUnit.type2DisplayUnitId,
          paneConfig: {
            nextMessage: info.nextMessage,
            nextPaneBg: info.nextPaneBg,
            isExecutable: this.isExecuteRepro(formattedData.reproExecutable)
          }
        };
        this.setTargetUnit(param);
      }
    },

    // 許諾変更モーダル関連----------------------
    // 許諾変更モーダル表示
    openConsentModal: async function (showData) {
      const item = this.getFormattedTargetUnitData(showData);
      if (item !== null) {
        this.unitId = item.id;
        const ecuList = [];
        this.processing = true;
        let response = null;
        // どのリプロ種別の許諾が押下されたのか判断する
        if (this.displayReproTypeMode === 'campaign') {
          this.selectSwidConsentType = config.REPRO_TYPE_NORMAL;
        }
        else if (this.displayReproTypeMode === 'update') {
          this.selectSwidConsentType = config.REPRO_TYPE_MERCHANTABILITY;
        }
        else {
          this.selectSwidConsentType = config.REPRO_TYPE_RESTORE;
        }
        response = await api.getCall(config.REPRO, '/netApps/' + this.netAppId + '/' + this.unitId + '/swids' + '/consent/' + this.pfcId);

        this.processing = false;
        handler.validate(handler.validateTypes.all, response, this, null, () => {

          // SWID お客様承諾のボタン押下時の処理
          if (response.data.consent_status === config.STATUS_UPDATE_CONSENT) {
            this.consentState = { order: 0, label: 'message.status_vehicle_system_consent' };
          } else if (response.data.consent_status === config.STATUS_UPDATE_REJECT) {
            this.consentState = { order: 1, label: 'message.status_vehicle_system_not_consent' };
          } else if (response.data.consent_status === config.STATUS_CONSENT_UNSETTED) {
            this.consentState = { order: 2, label: 'message.status_vehicle_system_not_set_yet' };
          } else {
            // それ以外の場合「‐」を設定
            this.consentState = { order: 99, label: 'message.common_hyphen' };
          }
          for (const ecu of response.data.ecus) {
            // 車両のSWIDとリプロ後のSWIDが一致しているシステムは表示しない。
            if (ecu.swid === ecu.latest_swid) continue;
            // ダイアログに表示する値に変換する。
            ecuList.push({ name: this.putSystemNameById(ecu.id), current: ecu.swid, latest: ecu.latest_swid });
          }

          this.consentTable = {
            ecus: ecuList
          };
          this.showModalConsent = true;
        }, (result) => {
          this.processing = false;
          if (response.data.code === Error.CONTINUOUS_REPRO_UPDATE_OF_CONSENT_ERROR) {
            // 関連リプロ途中通知ダイアログの表示
            // 公開ファイル一覧から関連リプロ対象のECU名を取得して、警告メッセージを作成
            const warningMessage = this.$t('message.message_vehicle_continuous_repro_update_of_consent_error') + '<br/>' + this.getRelationReproMessage();
            alert.showWarning(this, null, warningMessage, () => { });
          } else {
            // エラーダイアログの表示
            alert.showError(this, null, result.message, () => {
              // 処理が失敗した際にdialogが表示されていたら閉じる
              this.showModalConsent = false;
              if (result.behaviorType === handler.behaviorTypes.logout) this.logout(this);
            });
          }
          return;
        }, null, false);
      }
    },

    // 承諾または非承諾を設定
    updateConsentState: async function (state) {
      const consentMsg = 'message.message_vehicle_system_change_to_consent';  // 承諾時の成功メッセージ
      const rejectMsg = 'message.message_vehicle_system_change_to_reject';   // 非承諾時の成功メッセージ
      const formattedMsg = state === 'consented' ? consentMsg : rejectMsg;
      let response = null;
      this.processing = true;
      // SWID の場合は、どのリプロ種別の許諾が押下されたのか判断する
      response = await api.postCall(config.REPRO, '/netApps/' + this.netAppId + '/' + this.unitId + '/swids' + '/consent/' + this.pfcId, { consent_status: state });
      this.processing = false;
      this.showModalConsent = false; //ダイアログを閉じる
      handler.validate(handler.validateTypes.all, response, this, null, () => {
        this.$refs.informationContents.updateData({ pfc_file_id: this.pfcId, swid_consent: state });
        this.$emit('setModalQueueAvailable', false);// 許諾更新後のテーブル再取得では、各種ダイアログを表示しない
        this.$emit('refreshAllReproSystems');       // テーブル情報再取得
      }, (result) => {
        if (result.behaviorType === handler.behaviorTypes.logout) {
          this.logout(this);
        }
        return;
      }, formattedMsg, true);
    },
    // 対象ユニットIDをシステム名に変換する関数
    putSystemNameById: function (unitId) {
      const targetUnitDisplayData = vehicle.getTargetUnitDisplayNames(this.resources, this.language);
      const systemId = unitId;
      const unitName = targetUnitDisplayData[systemId];
      return unitName;
    },

  },

  computed: {
    ...mapState({
      authGroup: state => state.userProperty.group,
      resources: state => state.masterResources.targetUnits,
      vehicleModelDisplayNameList: state => state.masterResources.vehicleModelDisplayNameList,
      netAppId: state => state.netAppConnector.pairingAppId,
      selectedSystem(state) {
        if (state.targetUnit.unitInfo) {
          const targetUnitDisplayData = vehicle.getTargetUnitDisplayNames(state.masterResources.targetUnits, state.systems.language);
          let unitName = '';
          if (state.targetUnit.unitInfo.type2DisplayUnitId) {
            unitName = targetUnitDisplayData[state.targetUnit.unitInfo.type2DisplayUnitId] || '';
          } else {
            unitName = targetUnitDisplayData[state.targetUnit.unitInfo.unitId] || '';
          }
          if (unitName) {
            return `- ${unitName}`;
          }
        }
        return '';
      },
      treeViewHeight(state) {
        const height = state.app.clientHeight - 65;
        return height;
      },
      vehicleInfo: state => state.cache.vehicleInfo,
      cachedTargetInfo: state => state.userProperty.userCache[config.USER_CACHE_REPRO_TARGET_INFO],
      systemTable: state => state.table.systemTable,
      cachedSystemTable: state => state.cache.systemTable,
      cachedUnconformedSystems: state => state.cache.unconformedSystems,
      isPublishedVisible: state => state.cache.showPublished,
      viewMode: state => state.app.viewProcessMode,
      isTestMode: state => state.netAppConnector.isTestMode,
      inquiryStatus: state => state.vehicle.status,
      vehicleError: state => state.vehicle.error,
      watcher: state => state.vehicle.watcher,
      targetUnit: state => state.targetUnit.unitInfo,
      language: state => state.systems.language,
      showSystemTblModal: state => state.table.showSystemTblModal,
      isTechnicalHq: state => state.userProperty.userInfo.isTechnicalHq,
      allDtcSystems: state => state.table.allDtcSystems,
      displayMode: state => state.cache.showPublished,
      displayReproTypeMode: state => state.cache.showDisplayVehicle,
      isDisplayReproTabs: state => state.table.isReproSupport,
      // 機能の利用可否
      isReproVisible: state => state.userProperty.functionAvailability[config.EXECUE_FUNCTION_TYPE_RPR],
      serialNumber: state => state.cache.serialNumber,
      selectMerchandiseInfo: state => state.cache.selectMerchandiseInfo,
      individualMenus: state => state.vehicle.individualMenus,
    }),

    // どの機能タブを選択したか指定するためのプロパティ
    funcRepro() {
      return config.EXECUE_FUNCTION_TYPE_RPR;
    },
    // タブの表示・非表示を制御
    isDisplayTab() {
      // 一つ以上 true があれば true を返す
      return this.activeTabArray.includes(true);
    }
  },

  /* eslint-disable complexity */
  async created() {
    // リプロ失敗画面 ⇒ Vehicle 画面に遷移したときにペアリングを解除するが、そのときに車両情報のキャッシュを
    // クリアするため、null 参照を回避するため所定の条件ではユーザーキャッシュの SU フローフラグを参照する。
    this.suFlow = !this.vehicleInfo ? this.cachedTargetInfo.vehicle.is_su_flow : this.vehicleInfo.vehicle.is_su_flow;
    // アクティブなタブを設定
    const currentRoute = this.$router.currentRoute.value.name;

    // リプログラミングのタブ名前切り替え
    this.changeReproFuncTabName(this.displayReproTypeMode);

    if (util.isFromSettingsPage(util.getPreviousDisplayName(this.$route))) {
      // パスワード変更または単位設定画面から戻った場合はキャッシュ情報を使用
      this.isPublished = this.displayMode;
      this.systemTables = this.cachedSystemTable;
      this.unconformedSystems = this.cachedUnconformedSystems;
    } else {
      if (this.isReproFuncAvailable()) {
        // リプロ機能を利用可能なユーザーの場合、リプロ対象システム一覧を作成
        // システム一覧のテーブル作成
        const ccuPblTmp = this.setCcuFlag(this.systemTable.published);
        const ccuUnpblTmp = this.setCcuFlag(this.systemTable.unpublished);
        const tmpPbl = resource.getVehicleSystemStatus(ccuPblTmp, this.suFlow);
        const tmpUnpbl = resource.getVehicleSystemStatus(ccuUnpblTmp, this.suFlow);
        if (this.isTestMode) {
          const publishedUnitListTestModeTemp = JSON.parse(JSON.stringify(publishedUnitListTestMode));
          for (let index = 0; index < tmpPbl.vehicleSystemList.length; ++index) {
            tmpPbl.vehicleSystemList[index].name = publishedUnitListTestModeTemp[index].name;
            tmpPbl.vehicleSystemList[index].fieldSpec.isCommunicatable = config.LIST_ITEM_DISABLE;
            tmpPbl.vehicleSystemList[index].fieldSpec.isInstallation = config.LIST_ITEM_DISABLE;
          }
        }

        this.hasVehicleConnectWarn = reprogram.hasFailedStateUnit(this.systemTable.published, this.resources) || reprogram.hasFailedStateUnit(this.systemTable.unpublished, this.resources);
        if (this.isTestMode) {
          this.systemTables = {
            published: this.formatTable(tmpPbl.vehicleSystemList),
            unpublished: this.formatTable(tmpUnpbl.vehicleSystemList)
          };
        } else {
          this.systemTables = {
            published: this.formatTable(this.filterSmtRkeList(tmpPbl.vehicleSystemList)),
            unpublished: this.formatTable(this.filterSmtRkeList(tmpUnpbl.vehicleSystemList))
          };
        }
        this.cacheSystemTable(this.systemTables);
        this.changeReproFuncTabName(this.displayReproTypeMode);
        // 法規不適合のシステムが存在する場合は、警告色のテーブル表示に変更
        if (this.suFlow) this.changeToUnconformedDisplay();
        // サインアウト⇒リプロ復帰⇒システム個別画面表示の操作手順の特別対応
        if (this.targetUnit && this.targetUnit.directRecoveryToRpr) this.setPreviousTarget();
        // 公開・非公開一覧のどちらを初期表示とするか
        this.isPublished = this.isPublishedVisible;
        // Modal Queue 準備・開始

        // リプロ中サインアウト⇒リプロ復帰のときは Modal Queue を表示しない制御
        const isReproNotRunning = this.viewMode !== config.PROCESS_REPRO_PROCESSING && this.viewMode !== config.PROCESS_REPRO_COMPLETED;
        const isVehicleRoute = currentRoute === 'systemTable' || currentRoute === 'suSystemTable';
        const dialogExecuteFlag = isReproNotRunning && isVehicleRoute;
        // SBR 問い合わせダイアログの有無を確認する
        if (!this.vehicleInfo.vehicle.is_configuration_consistent && this.vehicleInfo.vehicle.is_su_flow) {
          if (dialogExecuteFlag) this.sbrConfirmDialog();
        } else {
          await this.setupModalQueue();
          if (dialogExecuteFlag) this.runModalQueue();
        }
      }
      if (this.isDiagFuncAvailable()) {
        // noop
      }
    }
  },

  mounted() {
    // 親のツリービューを更新
    if (this.selectMerchandiseInfo) {
      // 商品コードが選択されている状態であれば、商品に対してリプロありになっているシステムでツリーを更新する
      this.getPfcFileList(this.selectMerchandiseInfo, true);
      this.$emit('updateReproTreeView', { isPublished: this.isPublished });
    }

    this.$emit('updateAllDtcTreeView');
    this.$emit('updateDiagTreeView');
    this.$emit('updateMacTreeView');
    this.$emit('updateImmobilizerTreeView');
    this.$emit('updateSpecialFeatureTreeView');
    this.$emit('updateRealWorldDataTreeView');
  },

  beforeUnmount() {
    this.$stopInterval(this.watcher);
  },
};